import axios from "axios";
import React, { useState, useEffect } from "react";
import { baseUrl } from "../constant.js";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import Closetrade from "./Closetrade";
import Cancleorder from "./Cancleorder.js";
import { liveRateUrl } from "../constant.js";
import { Link } from "react-router-dom";

// const customStyles = {
//   content: {
//     width: '400px',
//     height: '200px',
//     margin: 'auto',
//     border: '1px solid #ccc',
//     borderRadius: '4px',
//     padding: '20px',
//   },
// };

const Activetrade = ({
  name,
  expary,
  ordertimrdate,
  holdingmargin,
  marginused,
  bid,
  bidtype,
  lot,
  orderid,
  closeordertype,
  ordertype1,
  clickfun,
  dataOrderid,
  catid,
}) => {
  const [type, setType] = useState("2");
  const [close, setClose] = useState("");
  const [message, setmessage] = useState("");
  const [popupicon, setpopupicon] = useState("assets/img/icons/failed.png");
  const [isOpen, setIsOpen] = useState(false);
  const [status, setstatus]= useState()
  const navigate = useNavigate();
  console.log(message);
  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
    clickfun(2, 2);
  };
  const closeModal1 = () => {
    setIsOpen(false);
  };
  const ordertype = async () => {
    const id = localStorage.getItem("users");
    const token = localStorage.getItem("token");
    const formdata = new FormData();
    formdata.append("Token", token);
    formdata.append("orderID", orderid);
    formdata.append("type", type);
    const result = await axios.post(
      baseUrl + `authController/closeCancelTrade`,
      formdata,
    );
    setmessage(result.data.message);
    setstatus(result.data.status)
    if(result.data.status === 1)
    {
      setpopupicon("assets/img/icons/checked.png");
    }
    else
    {
      setpopupicon("assets/img/icons/failed.png");
    }
    console.log(result.data.status)
    openModal();
  };
  useEffect(() => {
    const auth = localStorage.getItem("token");
    if (auth) {
    } else {
      navigate("/login");
    }

    if (ordertype1 == 1) {
      setClose("Market");
    } else if (ordertype1 == 2) {
      setClose("Order");
    } else if (ordertype1 == 3) {
      setClose("SL");
    } else if (ordertype1 == 4) {
      setClose("Admin");
    } else if (ordertype1 == 5) {
      setClose("Carried Forward");
    } else if (ordertype1 == 6) {
      setClose("Month Settlement");
    }
  });
  const token = localStorage.getItem("token");
  const onbuttonclick = async () => {
    const token1 = token;
    const tokenheader = localStorage.getItem("token");
    const formdata = new FormData();
    formdata.append("Token", tokenheader);
    formdata.append("catToken", token1);
    const rate = await axios.post(liveRateUrl, formdata);
    const fathdata = await rate.data.livedata[0];

    navigate("/markettrade", {
      state: {
        name: name,
        token: "ABB-I",
        catid: catid,
        exparydate: expary,
      },
    });
  };
  console.log(name, token, catid, expary);
  return (
    <>
      <Modal isOpen={isOpen} onRequestClose={closeModal1}>
       <img
          src={popupicon}
          className="img-fluid color_icons"
        />
        <h2>Order Detail</h2>
        <p>{message}</p>
        <button onClick={closeModal}>Close</button>
      </Modal>

      

      {name ? (
        <div className="futures_List">
          <div className="trades_List_text">
            <div className="traders_button" style={{ marginBottom: "7px 0px" }}>
              {bidtype == 2 && (
                <span
                  style={{
                    border: "1px solid red",
                    marginRight: "6px",
                    padding: "2px 10px",
                    color: "red",
                    borderRadius: "5px",
                    fontSize: "10px",
                  }}
                >
                  SellX{lot}
                </span>
              )}
              {bidtype == 1 && (
                <span
                  style={{
                    border: "1px solid #0dcaf0",
                    marginRight: "6px",
                    padding: "2px 10px",
                    color: "#0dcaf0",
                    borderRadius: "5px",
                    fontSize: "10px",
                  }}
                >
                  BuyX{lot}
                </span>
              )}
              <span
                style={{
                  border: "1px solid #ed0017",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: "#ed0017",
                  borderRadius: "5px",
                  fontSize: "10px",
                }}
              >
                {close}
              </span>
            </div>
            <h3 onClick={onbuttonclick}>
              {name}_{expary}
            </h3>
            <h5>Sold by Trader</h5>
            <p>{ordertimrdate} </p>
          </div>
          <div className="trades_List_text text-right">
            {bidtype == 1 && (
              <div
                className="trades_amount_btn"
                style={{ marginBottom: "0px" }}
              >
                <span
                  className="trdes_span"
                  style={{
                    border: "1px solid #0dcaf0",
                    padding: "2px 10px",
                    color: "#0dcaf0",
                    borderRadius: "5px",

                    fontSize: "10px",
                    background: "transparent",
                  }}
                >
                  {bid}
                </span>
              </div>
            )}
            {bidtype == 2 && (
              <div
                className="trades_amount_btn"
                style={{ marginBottom: "0px" }}
              >
                <span
                  className="trdes_span"
                  style={{
                    border: "1px solid red",
                    padding: "2px 10px",
                    color: "red",
                    borderRadius: "5px",
                    fontSize: "10px",
                    background: "transparent",
                  }}
                >
                  {bid}
                </span>
              </div>
            )}

            <div className="traders_button" style={{ marginBottom: "7px" }}>
              <button
                type="button"
                onClick={() => ordertype()}
                style={{
                  border: "1px solid #ed0017",
                  padding: "2px 10px",
                  color: "#fff",
                  borderRadius: "5px",
                  fontSize: "10px",
                  background: "#ed0017",
                }}
              >
                Close Order
              </button>
            </div>
            <h5>Marginused :{marginused} </h5>
            <h5>Holding Mar.Req:{holdingmargin}</h5>
          </div>
        </div>
      ) : (
        <h1 style={{ color: "wheat" }}>no</h1>
      )}
    </>
  );
};

export default Activetrade;
